module.exports = __webpack_public_path__ + "media/LoopStart.2ffa0e96.mp4";